var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 501.551 501.551",
    style: {
      enableBackground: "new 0 0 501.551 501.551"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B64C"
    },
    d: "M178.678,168.229c-11.494-3.135-21.943-6.269-32.392-9.404c-2.09-1.045-4.18-1.045-5.224-2.09 c-11.494-5.224-21.943-10.449-30.302-16.718L102.4,54.335l-4.18-41.796h65.829l6.269,64.784L178.678,168.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B64C"
    },
    d: "M394.971,136.882c-6.269,5.224-14.629,10.449-24.033,14.629c-4.18,2.09-9.404,4.18-14.629,6.269 c-8.359,3.135-16.718,6.269-25.078,8.359l-5.224-92.996l-1.045-17.763h65.829L394.971,136.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B64C"
    },
    d: "M318.694,0v169.273c-9.404,2.09-19.853,4.18-30.302,5.225c-1.045,0-2.09,0-2.09,0 c-7.314,1.045-15.673,1.045-24.033,2.09c-3.135,0-6.269,0-9.404,0V0H318.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B64C"
    },
    d: "M253.91,113.894l9.404,61.649c-3.135,0-6.269,0-9.404,0c-1.045,0-2.09,0-3.135,0 c-10.449,0-19.853,0-30.302-1.045c-3.135,0-6.269-1.045-9.404-1.045c-5.224-1.045-10.449-1.045-14.629-2.09l-13.584-95.086 l-5.224-32.392l43.886-6.269l20.898-3.135L253.91,113.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M141.061,156.735c-11.494-5.224-21.943-10.449-30.302-16.718 c-8.359-6.269-14.629-12.539-19.853-19.853H72.098l-6.269-65.829h64.784L141.061,156.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M448.261,37.616l-8.359,82.547h-29.257c-4.18,5.224-9.404,11.494-15.673,15.673 c-6.269,5.224-14.629,10.449-24.033,14.629l10.449-95.086l2.09-16.718h64.784V37.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M216.294,77.322l-5.224,97.176c-5.224-1.045-10.449-1.045-14.629-2.09 c-6.269-1.045-11.494-2.09-17.763-3.135c-11.494-3.135-21.943-6.269-32.392-9.404l4.18-82.547 C150.465,77.322,216.294,77.322,216.294,77.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M286.302,31.347v143.151c-7.314,1.045-15.673,1.045-24.033,2.09c-3.135,0-6.269,0-9.404,0 c-1.045,0-2.09,0-3.135,0c-10.449,0-19.853,0-30.302-1.045V31.347H286.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M368.849,79.412l-11.494,78.367c-8.359,3.135-16.718,6.269-25.078,8.359 c-4.18,1.045-8.359,2.09-12.539,3.135c-9.404,2.09-19.853,4.18-30.302,5.224l15.673-104.49l13.584,2.09l8.359,1.045L368.849,79.412 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M410.645,120.163c-22.988,32.392-85.682,56.424-159.869,56.424s-136.882-24.033-159.869-56.424 H50.155l56.424,363.624c2.09,10.449,10.449,17.763,20.898,17.763h246.596c10.449,0,18.808-7.314,20.898-17.763l56.424-363.624 H410.645z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 250.775,
    cy: 314.514,
    rx: 127.478,
    ry: 66.873
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFries);
export default __webpack_public_path__ + "static/media/Fries.edbe4cc398e555aaad286ab0710ec449.svg";
export { ForwardRef as ReactComponent };